import { DatadogTransportAdapter } from '@/adapters/datadogTransport.adapter'
import { Ga4TransportAdapter } from '@/adapters/ga4Transport.adapter'

export type PageViewContext = {
  title: string
  location: string
  path: string
}

export type UserTrack = {
  userId: string
}

/**
 * Event transport interface
 */
export interface Transport {
  /**
   * Tracks an event
   *
   * @param event - The event name
   * @param context - The event context
   */
  track: (event: string, context: Record<string, unknown>) => void

  /**
   * Tracks a page view
   *
   * @param context - The page context
   * @param extras - The page extras
   */
  page: (context: PageViewContext, extras?: Record<string, unknown>) => void

  /**
   * Identify a user
   */
  identify: (user: UserTrack) => void
}

/**
 * All global transports
 */
const transports: Array<Transport> = [
  new Ga4TransportAdapter(),
  new DatadogTransportAdapter(),
]

/**
 * Method responsible for registering a new custom transport
 *
 * @param transport
 */
export const registerTransport = (transport: Transport) =>
  transports.push(transport)

/**
 * Method responsible for getting all existing transports
 *
 * @returns All existing transports
 */
export const getTransports = () => transports
